import { InitialValues } from 'forms/types';

import { BloodPressureFormValues } from '../form/types';
import { BloodPressureProfileQuery } from '../graphql/BloodPressureProfile';

const buildInitialValues = (
  data?: BloodPressureProfileQuery
): InitialValues<BloodPressureFormValues> => {
  const bloodPressureProfile = data?.bloodPressure;

  return {
    systolicPressure: bloodPressureProfile?.systolicPressure ?? 0,
    diastolicPressure: bloodPressureProfile?.diastolicPressure ?? 0,
    lastTreatedAt: bloodPressureProfile?.lastTreatedAt,
    controlledWithMedication: bloodPressureProfile?.controlledWithMedication,
    controlledWithMedicationSince: bloodPressureProfile?.controlledWithMedicationSince,
  };
};

export default buildInitialValues;
